import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';

import styles from './styles.scss';

import { Text, Button, Tooltip, Col } from 'wix-style-react';

class Widget extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    widgetObject: PropTypes.object,
    integrations: PropTypes.object.isRequired,
    appConfig: PropTypes.object.isRequired,
    navigation: PropTypes.object.isRequired,
    biLogger: PropTypes.object.isRequired,
    span: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleClick = () => {
    const { type, widgetObject, navigation, biLogger } = this.props;
    if (
      this.props.appConfig.experiments[
        'specs.promote.mi.ui.marketingIntegrationTPAs'
      ] === 'true'
    ) {
      if (widgetObject && widgetObject.redirect) {
        navigation.navigateToAppMarket(widgetObject.redirect);
      } else {
        navigation.openWidget(widgetObject.name);
      }
      biLogger.integrationClick({ type: widgetObject.name });
    } else {
      navigation.openWidget(type);
      biLogger.integrationClick({ type });
    }
  };

  render() {
    const {
      type, // fixme(yanir) should be removed if experiment is successful (specs.promote.mi.ui.marketingIntegrationTPAs widget objects)
      widgetObject,
      integrations,
      appConfig: { staticsBaseUrl },
      span,
      t,
    } = this.props;
    let resolvedType;
    let buttonText;

    if (
      this.props.appConfig.experiments[
        'specs.promote.mi.ui.marketingIntegrationTPAs'
      ] === 'true'
    ) {
      if (widgetObject && widgetObject.redirect) {
        resolvedType = widgetObject.name;
        buttonText = t('marketing-integration.dashboard.widget.add-app-button');
      } else {
        resolvedType = widgetObject.name;
        buttonText = t('dashboard.widget.button');
      }
    } else {
      resolvedType = type;
      buttonText = t('dashboard.widget.button');
    }

    const widget = integrations.getWidgetConfig(resolvedType);
    return widget ? (
      <Col span={span} dataHook={`widget-container-${resolvedType}`}>
        <div className={styles.widgetContainer}>
          <div className={styles.widgetHeader}>
            <img
              src={`${staticsBaseUrl}assets/integrations-images-dashboard/${resolvedType}.png`}
              alt=""
            />
          </div>
          <div className={styles.divider} />
          <div className={styles.widgetContent}>
            <Text>
              <p className={styles.description}>{t(widget.description)}</p>
            </Text>
            <Tooltip
              content={t(
                'marketing-integration.dashboard.widget.no-permission',
              )}
              textAlign="center"
              disabled={widget.isPermitted}
            >
              <div className={styles.startButton}>
                <Button
                  dataHook={`action-button-${resolvedType}`}
                  onClick={this.handleClick}
                  size="small"
                  priority="secondary"
                  disabled={!widget.isPermitted}
                >
                  {buttonText}
                </Button>
              </div>
            </Tooltip>
          </div>
        </div>
      </Col>
    ) : null;
  }
}

export default translate()(
  inject(
    'integrations',
    'appConfig',
    'navigation',
    'biLogger',
  )(observer(Widget)),
);
